import { ComponentProps } from "@ts/components";
import React, { FC, useMemo } from "react";

export type BreadcrumbItem = {
  title?: string;
  url?: string;
};

export type BreadcrumbInputProps = ComponentProps & {
  paths: BreadcrumbItem[];
  hideHomepageLink?: boolean;
  float?: boolean;
};

export type BreadcrumbOutputProps = BreadcrumbInputProps;

export const withBreadcrumb =
  (Component: FC<BreadcrumbOutputProps>) =>
  ({
    name = "Breadcrumb",
    paths: additionalPaths,
    float,
    hideHomepageLink,
  }: BreadcrumbInputProps) => {
    const paths = useMemo<BreadcrumbItem[]>(() => {
      if (hideHomepageLink) return additionalPaths;

      return [
        {
          title: "Home",
          url: "/",
        },
        ...additionalPaths,
      ];
    }, [hideHomepageLink, additionalPaths]);

    Component.displayName = name;
    return <Component paths={paths} float={float} />;
  };
